import type { Interpolation, Theme } from '@emotion/react'
import type { CSSProperties } from 'react'
import React from 'react'
import { layersNavigationMenuStore } from 'stores/layersNavigationMenuStore/layersNavigationMenuStore'
import { useScreenOrientation } from 'stores/smallStore/smallStore'
import { useIsWideScreen } from 'utils/useIsWideScreen'
import { usePreventPanelDetailsFromBeingOpen } from 'utils/usePreventPanelDetailsFromBeingOpen'

type MapActionIconsProps = {
  children: React.ReactNode
}

export const MapActionIcons: React.FC<MapActionIconsProps> = ({ children }) => {
  const isWideScreen = useIsWideScreen()
  const screenOrientation = useScreenOrientation()
  const preventPanelDetailsFromBeingOpen = usePreventPanelDetailsFromBeingOpen()
  const menuCollapsed = layersNavigationMenuStore.useSelector((s) => s.menuCollapsed)

  const wrapperStyle: Interpolation<Theme> & CSSProperties = isWideScreen
    ? {
        'display': 'flex',
        'flexDirection': 'column-reverse',
        'position': 'absolute',
        'left': menuCollapsed ? '10px' : '320px',
        'bottom': 10,
        'margin':
          'env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)',
        '> *': {
          marginBottom: 10,
        },
      }
    : {
        'display': 'flex',
        'flexDirection': 'column',
        'position': 'absolute',
        'top': 60,
        'right': !preventPanelDetailsFromBeingOpen && screenOrientation === 'landscape' ? '75px' : '12px',
        'margin':
          'env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)',
        '> *': {
          marginTop: 10,
        },
      }

  return <div css={wrapperStyle}>{children}</div>
}
